import { topicsData } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">大家都在讨论的影视热点</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-primary-50 transition-colors duration-200 cursor-pointer relative"
            >
              {topic.tag && (
                <span className="absolute top-2 right-2 px-1.5 py-0.5 bg-accent-500 text-background-50 rounded text-[10px] font-semibold leading-tight">
                  {topic.tag}
                </span>
              )}
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-50 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${topic.icon} text-xl md:text-2xl text-primary-600`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-500">{topic.heat}</span>
            </a>
          ))}
        </div>

        <div className="mt-4 flex justify-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-2 px-4 py-2 bg-background-100 rounded-full">
            {topicsData.map((topic) => (
              <span
                key={topic.id}
                className="whitespace-nowrap px-2.5 py-1 text-xs text-foreground-600 hover:text-primary-600 cursor-pointer transition-colors"
              >
                #{topic.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}